/**
 * 全角から半角へ変換
 */
const replaceFullToHalf = (str: string) => {
  let cvnStr;
  cvnStr = str.replace(/[！-～]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0));
  // eslint-disable-next-line no-irregular-whitespace
  cvnStr = str.replace(/　/g, ' ');
  return cvnStr;
};

export default replaceFullToHalf;
